export const hasProperty = (obj: object, key: string): boolean => {
  return Object.prototype.hasOwnProperty.call(obj, key);
};

export const parseStringObject = (obj: Record<string, string>): Record<string, any> => {
  const newObj: Record<string, any> = JSON.parse(JSON.stringify(obj));
  Object.entries(newObj).forEach(([key, value]) => {
    switch (value) {
      case 'true':
        newObj[key] = true;
        break;
      case 'false':
        newObj[key] = false;
        break;
      case 'null':
        newObj[key] = null;
        break;
      case 'undefined':
        newObj[key] = undefined;
        break;
      default:
        newObj[key] = value;
        break;
    }
  });
  return newObj;
};
